export default __webpack_public_path__ + "static/media/11.b4a13a9d.png";